import React, { useEffect, useState } from 'react'
import { AlertCircleIcon, CheckCircle2Icon, InboxIcon, ListTodoIcon } from 'lucide-react'
import { Link } from 'react-router-dom'
import { fetchInboxDashboardCounts } from '../../api/inboxFeed'

interface InboxTodayWidgetProps {
  userId: string | null
}

export function InboxTodayWidget({ userId }: InboxTodayWidgetProps) {
  const [counts, setCounts] = useState({
    staffUnassigned: 0,
    overdueTasks: 0,
    myOpenTasks: 0,
    needsResponse: 0,
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchInboxDashboardCounts(userId)
      .then(setCounts)
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [userId])

  if (loading) return null

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <InboxIcon className="w-5 h-5 text-blue-600" />
          Inbox today
        </h3>
        <Link to="/messages?tab=external" className="text-sm text-blue-600 hover:underline">
          Open inbox
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatChip
          label="Staff unassigned"
          value={counts.staffUnassigned}
          warn={counts.staffUnassigned > 0}
          icon={AlertCircleIcon}
        />
        <StatChip label="My open tasks" value={counts.myOpenTasks} icon={ListTodoIcon} />
        <StatChip
          label="Overdue tasks"
          value={counts.overdueTasks}
          warn={counts.overdueTasks > 0}
          icon={AlertCircleIcon}
        />
        <StatChip
          label="Needs response"
          value={counts.needsResponse}
          warn={counts.needsResponse > 0}
          icon={CheckCircle2Icon}
        />
      </div>
    </div>
  )
}

function StatChip({
  label,
  value,
  warn,
  icon: Icon,
}: {
  label: string
  value: number
  warn?: boolean
  icon: React.ElementType
}) {
  return (
    <div className={`rounded-lg border p-3 ${warn ? 'border-amber-200 bg-amber-50' : 'border-gray-200 bg-gray-50'}`}>
      <div className="flex items-center gap-2 text-xs text-gray-500 mb-1">
        <Icon className={`w-4 h-4 ${warn ? 'text-amber-600' : 'text-gray-400'}`} />
        {label}
      </div>
      <p className={`text-2xl font-bold ${warn ? 'text-amber-700' : 'text-gray-900'}`}>{value}</p>
    </div>
  )
}
